import { LINKS } from "../../../config/links";

export const ADDRESS_CONFIG = {
    default: {
        sectionId: "address",
        blocks: [
            {
                key: "contact",
                type: "company",
                links: [
                    {
                        kind: "phone",
                        href: LINKS.contact.phone,
                        textKey: "default.blocks.contact.info.phoneDisplay",
                        titleKey: "common.labels.phoneTitle",
                    },
                    {
                        kind: "email",
                        href: LINKS.contact.email,
                        textKey: "default.blocks.contact.info.emailDisplay",
                        titleKey: "common.labels.emailTitle",
                    },
                ],
            },
            {
                key: "czorsztyn",
                type: "location",
                links: [
                    {
                        kind: "maps",
                        href: LINKS.external.mapsCzorsztyn,
                        textKey: "common.actions.navigateGoogleMaps",
                        titleKey: "common.labels.mapsTitle",
                    },
                    {
                        kind: "tour",
                        href: LINKS.external.tourCzorsztyn,
                        textKey: "common.actions.virtualTourCzorsztyn",
                        titleKey: "common.labels.tourCzorsztynTitle",
                    },
                ],
            },
            {
                key: "niedzica",
                type: "location",
                links: [
                    {
                        kind: "maps",
                        href: LINKS.external.mapsNiedzica,
                        textKey: "common.actions.navigateGoogleMaps",
                        titleKey: "common.labels.mapsTitle",
                    },
                    {
                        kind: "tour",
                        href: LINKS.external.tourNiedzica,
                        textKey: "common.actions.virtualTourNiedzica",
                        titleKey: "common.labels.tourNiedzicaTitle",
                    },
                ],
            },
        ],
    },

    cruises: {
        sectionId: "address",
        blocks: [
            {
                key: "contact",
                type: "textContact",
                links: [
                    {
                        kind: "phone",
                        href: LINKS.contact.phone,
                        textKey: "cruises.blocks.contact.phoneDisplay",
                        titleKey: "common.labels.phoneTitle",
                    },
                    {
                        kind: "email",
                        href: LINKS.contact.email,
                        textKey: "cruises.blocks.contact.emailDisplay",
                        titleKey: "common.labels.emailTitle",
                    },
                ],
            },
            {
                key: "czorsztyn",
                type: "location",
                links: [
                    {
                        kind: "maps",
                        href: LINKS.external.mapsCzorsztyn,
                        textKey: "common.actions.navigateGoogleMaps",
                        titleKey: "common.labels.mapsTitle",
                    },
                    {
                        kind: "tour",
                        href: LINKS.external.tourCzorsztyn,
                        textKey: "common.actions.virtualTourCzorsztyn",
                        titleKey: "common.labels.tourCzorsztynTitle",
                    },
                ],
            },
            {
                key: "niedzica",
                type: "location",
                links: [
                    {
                        kind: "maps",
                        href: LINKS.external.mapsNiedzica,
                        textKey: "common.actions.navigateGoogleMaps",
                        titleKey: "common.labels.mapsTitle",
                    },
                    {
                        kind: "tour",
                        href: LINKS.external.tourNiedzica,
                        textKey: "common.actions.virtualTourNiedzica",
                        titleKey: "common.labels.tourNiedzicaTitle",
                    },
                ],
            },
        ],
    },

    bikesRental: {
        sectionId: "address",
        blocks: [
            {
                key: "contact",
                type: "textContact",
                links: [
                    {
                        kind: "phone",
                        href: LINKS.contact.bikesRentalPhone,
                        textKey: "bikesRental.blocks.contact.phoneDisplay",
                        titleKey: "common.labels.phoneTitle",
                    },
                    {
                        kind: "email",
                        href: LINKS.contact.bikesRentalEmail,
                        textKey: "bikesRental.blocks.contact.emailDisplay",
                        titleKey: "common.labels.emailTitle",
                    },
                ],
            },
            {
                key: "location",
                type: "locationSingle",
                links: [
                    {
                        kind: "maps",
                        href: LINKS.external.bikesRentalMaps,
                        textKey: "bikesRental.blocks.location.navigate",
                        titleKey: "common.labels.mapsTitle",
                    },
                ],
            },
        ],
    },

    houses: {
        sectionId: "address",
        blocks: [
            {
                key: "contact",
                type: "housesContact",
                links: [
                    {
                        kind: "phone",
                        href: LINKS.contact.housesPhone,
                        textKey: "houses.blocks.contact.phoneDisplay",
                        titleKey: "houses.blocks.location.phoneTitle",
                    },
                    {
                        kind: "booking",
                        href: LINKS.external.housesBooking,
                        textKey: "houses.blocks.contact.bookingText",
                    },
                    {
                        kind: "rules",
                        href: LINKS.external.housesRulesPdf,
                        textKey: "houses.blocks.contact.rulesText",
                    },
                ],
            },
            {
                key: "location",
                type: "locationSingle",
                links: [
                    {
                        kind: "maps",
                        href: LINKS.external.housesMaps,
                        textKey: "houses.blocks.location.navigate",
                        titleKey: "houses.blocks.location.mapsTitle",
                    },
                ],
            },
        ],
    },
    boats: {
        sectionId: "address",
        blocks: [
            {
                key: "contact",
                type: "textContact",
                links: [
                    {
                        kind: "phone",
                        href: LINKS.contact.bikesRentalPhone,
                        textKey: "bikesRental.blocks.contact.phoneDisplay",
                        titleKey: "common.labels.phoneTitle",
                    },
                    {
                        kind: "email",
                        href: LINKS.contact.bikesRentalEmail,
                        textKey: "bikesRental.blocks.contact.emailDisplay",
                        titleKey: "common.labels.emailTitle",
                    },
                ],
            },
            {
                key: "location",
                type: "locationSingle",
                links: [
                    {
                        kind: "maps",
                        href: LINKS.external.bikesRentalMaps,
                        textKey: "bikesRental.blocks.location.navigate",
                        titleKey: "common.labels.mapsTitle",
                    },
                ],
            },
        ],
    },
};